import * as THREE from 'three'

const zone_depth = 0.05
const extrude_settings = {
    depth: zone_depth,
    bevelEnabled: false,
    // bevelSegments: 2,
    steps: 2,
    // bevelSize: 0.1,
    // bevelThickness: 1,
}

const plate_width = 17 / 12

const plate_height_first_bit = Math.sqrt(
    plate_width ** 2 / 2 - (plate_width / 2) ** 2
)
const vertical_plate_height = 8.5 / 12

const plate_shape = new THREE.Shape()
    .moveTo(0, 0)
    .lineTo(plate_width / 2, plate_height_first_bit)
    .lineTo(plate_width / 2, plate_height_first_bit + vertical_plate_height)
    .lineTo(-plate_width / 2, plate_height_first_bit + vertical_plate_height)
    .lineTo(-plate_width / 2, plate_height_first_bit)
    .lineTo(0, 0)

// plate_shape.holes.push(plate_hole);
const plate_geometry = new THREE.ExtrudeGeometry(plate_shape, extrude_settings)

export default class HomePlate {
    constructor() {
        this.object = new THREE.Mesh(
            plate_geometry,
            new THREE.MeshBasicMaterial({ color: 0xefefef })
        )
    }
}
